import { render, staticRenderFns } from "./PayeeTaxForm.vue?vue&type=template&id=b07e943a&scoped=true&"
import script from "./PayeeTaxForm.vue?vue&type=script&lang=ts&"
export * from "./PayeeTaxForm.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeTaxForm.vue?vue&type=style&index=0&id=b07e943a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e943a",
  null
  
)

export default component.exports